import { render, staticRenderFns } from "./VAppBar.vue?vue&type=template&id=56f9c562&"
import script from "./VAppBar.vue?vue&type=script&lang=js&"
export * from "./VAppBar.vue?vue&type=script&lang=js&"
import style0 from "./VAppBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports